import type { FC, HTMLAttributes, ReactNode } from 'react'
import { cx } from 'src/utils/cx'
import type { MioExpressionType } from './Common/MioImage'
import { MioExpression, MioImage } from './Common/MioImage'

export interface EmptyProps extends HTMLAttributes<HTMLDivElement> {
  mioExpression?: MioExpressionType
  image?: string
  imageClassName?: string
  description?: ReactNode
  action?: ReactNode
}

const Empty: FC<EmptyProps> = ({
  mioExpression,
  image,
  imageClassName,
  description,
  action,
  className,
  ...props
}) => {
  return (
    <div
      className={cx(
        'w-full p-8 flex flex-col items-center text-[24px] gap-4',
        className,
      )}
      {...props}
    >
      {image === undefined ? (
        <MioImage
          expression={mioExpression ?? MioExpression.Pokke}
          className={cx(imageClassName != null ? imageClassName : 'h-64')}
        />
      ) : (
        <img
          src={image}
          alt=""
          className={cx(imageClassName != null ? imageClassName : 'h-72')}
        />
      )}
      <div className="text-primary-light">{description}</div>
      {action}
    </div>
  )
}

export default Empty
